module.exports = __webpack_public_path__ + "img/swap-root.f69a58b9.svg";